if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (this.form) {
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      isPartialStockAdd(response) {
        var text = String((response && (response.description || response.message)) || '');
        return /only\s+\d+\s+items?\s+(?:was|were)\s+added to your cart due to availability/i.test(text);
      }

      refreshCartUI(variantId) {
        if (!this.cart || typeof this.cart.getSectionsToRender !== 'function') {
          return Promise.resolve();
        }
        var sectionIds = this.cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .filter(Boolean);
        if (!sectionIds.length) return Promise.resolve();

        var root =
          (window.Shopify && Shopify.routes && Shopify.routes.root) ||
          (window.routes && routes.root) ||
          '/';
        var url = root + '?sections=' + encodeURIComponent(sectionIds.join(','));

        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .then(
            function (sectionsHtml) {
              if (this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
              this.cart.renderContents({
                id: variantId,
                sections: sectionsHtml,
              });
              if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: variantId,
                });
              }
            }.bind(this)
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.querySelector('.product-form-btn-text').classList.add('opacity-0');
        this.querySelector('.tp-loading').classList.remove('opacity-0');

        const config = window.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const variantId = formData.get('id');

            if (response.status) {
              const rawMsg = response.description || response.message || '';
              this.handleErrorMessage(
                typeof window.bambeTranslateCartError === 'function'
                  ? window.bambeTranslateCartError(rawMsg)
                  : rawMsg
              );

              /* Shopify may still add max available stock on this 422 — refresh drawer/badge */
              if (this.isPartialStockAdd(response)) {
                this.error = false;
                return this.refreshCartUI(variantId).catch(function (e) {
                  console.error(e);
                });
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                const label = this.submitButton.querySelector('span');
                if (label) label.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }

            const availabilityNote = response.description || response.message;
            if (
              availabilityNote &&
              /due to availability|already in your cart|you can only add/i.test(availabilityNote)
            ) {
              this.handleErrorMessage(
                typeof window.bambeTranslateCartError === 'function'
                  ? window.bambeTranslateCartError(availabilityNote)
                  : availabilityNote
              );
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.product-form-btn-text').classList.remove('opacity-0');
            this.querySelector('.tp-loading').classList.add('opacity-0');
            const qucikView = this.closest('.tp-modal-quick-view');
            if (qucikView && qucikView.classList.contains('show')) {
              qucikView.classList.remove('show');
            }
            if (typeof window.loadContry === 'function') window.loadContry();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        if (errorMessage) {
          window.showNotifications(errorMessage);
        }
      }
    }
  );
}
